import { availabilityStyles as styles } from "@iewccouk/Overrides/Widgets/ProductDetails/ProductDetailsAvailability";
import { css } from "styled-components";

styles.availability = {
    ...styles.availability,
    messageGridItem: {
        ...styles.availability?.messageGridItem,
        css: css`
            ${styles.availability?.messageGridItem?.css}
            flex-direction: column;

            & > div {
                margin-bottom: 3px;
            }
        `,
    },
};
